import React from "react";
import { ValidateToken } from "../../../service/authServices";

export const UserRedirect = () => {
    
    ValidateToken();

    return(
        <React.Fragment />
    );
}